// extracted by mini-css-extract-plugin
module.exports = {"main":"GameLayout_main__1G_vX","question":"GameLayout_question__azhy_","player":"GameLayout_player__1a2nU","logo":"GameLayout_logo__1DK7U","title":"GameLayout_title__Fwkq2"};